import React from 'react';
import classNames from 'classnames';

import { Markdown } from '../../../../General/Markdown';

interface Props {
    info?: string;
    viisiNote?: string;
}

export const PropertyMarkdown: React.FC<Props> = ({ info, viisiNote }: Props) => (
    <>
        {info !== undefined && <Markdown text={info} />}
        {viisiNote !== undefined && (
            <>
                <p className={classNames('mb-0', { 'mt-2': info !== undefined })}>
                    <strong>Notitie</strong>
                </p>
                <Markdown text={viisiNote} />
            </>
        )}
    </>
);
